module.exports = __webpack_public_path__ + "img/reviews_mt_clickbait.8aa477de.svg";